import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import VisualQa from './VisualQa'
import UnifiedApp from './UnifiedApp'
import DeveloperExperiencePage from './DeveloperExperiencePage';
import Lens from './Lens';
import './tailwind.generated.css';

import {   
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom';

ReactDOM.render(
  <Router>
    <Switch>
      <Route path="/lens">
        <Lens />
      </Route>
      <Route path="/explorer">
        <DeveloperExperiencePage />
      </Route>
      <Route path="/tracer">
        <DeveloperExperiencePage />
      </Route>
      <Route path="/visualizer">
        <DeveloperExperiencePage />
      </Route>
      <Route path="/visualqa">
        <VisualQa />
      </Route>
      <Route path="/unifiedapp">
        <UnifiedApp />
      </Route>
      <Route path="/">
        <App />
      </Route>
    </Switch>
  </Router>,
  document.getElementById('root')
);
